
import { defineComponent, ref } from 'vue';

export default defineComponent({
    name: 'Toggle',

    setup() {
        const html = document.querySelector('html');
        const prefers = window.matchMedia('(prefers-color-scheme: dark)');
        const darkModeEnabled = ref(false);

        if (!html) return;

        if (prefers.matches) {
            html.dataset.mode = 'dark';
            darkModeEnabled.value = true;
        }

        const darkMode = () => {
            if (html.dataset.mode === 'dark') {
                html.dataset.mode = 'light';
                darkModeEnabled.value = false;
            } else {
                html.dataset.mode = 'dark';
                darkModeEnabled.value = true;
            }
        };

        return { darkModeEnabled, darkMode };
    },
});
